// useReducedMotion — historically wrapped the `prefers-reduced-motion:
// reduce` media query so components could opt out of inline animations.
//
// 2026-05-30 product decision: the event wants EVERY participant to get the
// full animation experience (the photo-reveal fade-in, atmosphere, the
// breathing dots) regardless of their OS "reduce motion" setting — several
// learners had it on and were silently getting static/instant versions.
// So this hook now ALWAYS returns false. The signature is kept so the ~10
// existing call sites need no change; they simply always take the animated
// branch. The companion CSS `@media (prefers-reduced-motion: reduce)` blocks
// (tokens.css, ArrivalOverlay) were removed for the same reason.

export function useReducedMotion(): boolean {
  return false;
}
